export default "__VITE_ASSET__JnD63kX4__"